import { put } from "redux-saga/effects";
import {
  PartialCreditHistoryResponseEnum,
  WalletHistoryResponse,
} from "redmond";
import { actions } from "../actions";
import { fetchTravelWalletCreditHistory } from "../../../api/v0/travel-wallet/fetchTravelWalletCreditHistory";

export function* fetchTravelWalletCreditHistorySaga(
  _: actions.IFetchTravelWalletCreditHistory,
) {
  try {
    const walletCreditHistory: WalletHistoryResponse =
      yield fetchTravelWalletCreditHistory();
    const { partialCredits } = walletCreditHistory;
    const isPartialSuccess =
      partialCredits?.PartialCreditHistoryResponse ===
      PartialCreditHistoryResponseEnum.Success;
    const creditHistory = isPartialSuccess
      ? partialCredits.credits
      : walletCreditHistory.credits;
    yield put(
      actions.setTravelWalletCreditHistory(
        creditHistory,
        isPartialSuccess ? partialCredits.validFromTime : undefined
      )
    );
    yield put(actions.fetchTravelWalletCreditHistoryCallStateSuccess());
  } catch (e) {
    yield put(actions.fetchTravelWalletCreditHistoryCallStateFailure());
  }
}
